import React from 'react';
import { get, startCase } from 'lodash';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import CardHeader from '../CardHeader';
import SubModule from '../SubModule';
import SubModuleContent from '../SubModuleContent';
import DetailsList from '../DetailsList';
import useAPI from '../../hooks/useAPI';
import { fetchContractStats } from '../../actions/driStats';
import styles from './ContractStats.style';

const baseColumns = [
  {
    key: 'icon',
    name: 'icon',
    headerClassName: styles.iconColumnHeader,
    iconClassName: styles.headerIcon,
    arianame: 'icon',
    iconName: 'TextDocument',
    isIconOnly: true,
    fieldName: 'icon',
    minWidth: 8,
    maxWidth: 8,
    columnActionsMode: 0,
    onRender: () => {
      return (
        <div className={styles.iconColumn}>
          <FontIcon iconName="TextDocument" arianame="TextDocument" />
        </div>
      );
    },
  },
  {
    key: 'silo',
    name: 'Contract Silo',
    fieldName: 'silo',
  },
  {
    key: 'status',
    name: 'Status',
    fieldName: 'status',
    onRender: contract => startCase(contract?.status),
  },
  {
    key: 'count',
    name: 'Count',
    fieldName: 'count',
  },
];

const moduleContent = (error, isLoading, data) => {
  if (error) {
    return (
      <MessageBar
        isMultiline={false}
        messageBarType={MessageBarType.error}
        dismissButtonAriaLabel="Close"
      >
        {error.name}: Try reloading or contact support.
      </MessageBar>
    );
  }
  const contractStats = Object.values(get(data, 'entities.stats', []));
  return (
    <DetailsList items={contractStats} columns={baseColumns} shimmered enableShimmer={isLoading} />
  );
};

const ContractStats = () => {
  const { error, data, isLoading } = useAPI(() => fetchContractStats());

  return (
    <>
      <CardHeader variant="large" leftBorder>
        Contract count based on Status
      </CardHeader>

      <SubModule>
        <SubModuleContent className={styles.moduleContent}>
          {moduleContent(error, isLoading, data)}
        </SubModuleContent>
      </SubModule>
    </>
  );
};

export default ContractStats;
